import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Raven from "../Raven/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dServices$dDelivery$dBackend from "../Restaumatic.Services.Delivery.Backend/index.js";
import * as Restaumatic$dServices$dGeocoding$dCached from "../Restaumatic.Services.Geocoding.Cached/index.js";
import * as Restaumatic$dServices$dGeocoding$dHiggs from "../Restaumatic.Services.Geocoding.Higgs/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic$dSite$dComponents$dDeliveryAddress from "../Restaumatic.Site.Components.DeliveryAddress/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Utils$dDOM from "../Utils.DOM/index.js";
import * as Web$dDOM$dElement from "../Web.DOM.Element/index.js";
import * as Web$dDOM$dNodeList from "../Web.DOM.NodeList/index.js";
import * as Web$dDOM$dParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web$dEvent$dEvent from "../Web.Event.Event/index.js";
import * as Web$dEvent$dEventTarget from "../Web.Event.EventTarget/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dLocation from "../Web.HTML.Location/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
const $DeliveryStatus = tag => ({tag});
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const newRef = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const attachEvent = /* #__PURE__ */ Specular$dCallback.attachEvent()(monadFRP);
const asyncRequestMaybe = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequestMaybe(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP);
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_(monadFRP);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableArray);
const for_2 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const UNKNOWN = /* #__PURE__ */ $DeliveryStatus("UNKNOWN");
const OK = /* #__PURE__ */ $DeliveryStatus("OK");
const OTHER = /* #__PURE__ */ $DeliveryStatus("OTHER");
const parseAccountId = v => bind(Foreign$dGeneric$dClass.intDecode.decode(v))(v1 => pure(v1));
const init = v => {
  const $0 = v.element;
  const $1 = v.siteId;
  const v1 = Restaumatic$dCountries.decodeCountry.decode(v.country);
  const country = (() => {
    if (v1.tag === "Right") {
      const $2 = v1._1;
      return $2;
    }
    if (v1.tag === "Left") {
      Raven.captureMessage("DeliveryForm: Invalid country")({country: Data$dShow.showStringImpl(v.country)})();
      return Restaumatic$dCountries.PL;
    }
    $runtime.fail();
  })();
  const form = Utils$dDOM.querySelectorOrThrow("form")($0)();
  const formPlaceholder = Utils$dDOM.querySelectorOrThrow(".js-delivery-form-placeholder")(form)();
  const addressEnv = {
    forceShowValidationErrors: (() => {
      const n = Specular$dInternal$dIncremental.constant(false);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })(),
    geocoding: Restaumatic$dServices$dGeocoding$dCached.cachedGeocoding({
      storage: Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback,
      key: "locationCache"
    })({geocodeAddress: Restaumatic$dServices$dGeocoding$dHiggs.geocodeAddress(Data$dMaybe.$Maybe("Just", v.accountId))(Data$dMaybe.Nothing)(false)}),
    storage: Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback
  };
  Specular$dDom$dWidget.runWidgetInNode(formPlaceholder)(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.local(env => ({...env, userEnv: addressEnv}))(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-delivery-address__container")
  ])(Restaumatic$dSite$dComponents$dDeliveryAddress.deliveryAddressWidget({
    country,
    accountId: v.accountId,
    restaurantId: Data$dMaybe.Nothing,
    withAptInfo: false,
    geocodingAddressE: Specular$dFRP$dBase.never
  }))))(v1$1 => {
    const $2 = v1$1.address;
    return Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dDeliveryAddress.geocodingStatus(false)(v1$1.status))(() => Specular$dInternal$dRIO.bindImpl(newEvent)(submit => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)($2))(initialAddress => Specular$dInternal$dRIO.bindImpl(newRef((() => {
      if (initialAddress.tag === "Nothing") { return false; }
      if (initialAddress.tag === "Just") { return true; }
      $runtime.fail();
    })()))(shouldSubmit => Specular$dInternal$dRIO.bindImpl(attachEvent(submit.event)(b => shouldSubmit._2(_old => true)))(() => Specular$dInternal$dRIO.bindImpl(Web$dEvent$dEventTarget.eventListener(ev => {
      const $3 = Web$dEvent$dEvent.preventDefault(ev);
      return () => {
        $3();
        return submit.fire()();
      };
    }))(listener => Specular$dInternal$dRIO.bindImpl(Web$dEvent$dEventTarget.addEventListener("submit")(listener)(true)(form))(() => Specular$dInternal$dRIO.bindImpl(asyncRequestMaybe(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v2 => v3 => {
      if (v2) {
        return Data$dMaybe.$Maybe(
          "Just",
          Restaumatic$dServices$dDelivery$dBackend.deliveringRestaurants($1)(v3.tag === "Just"
            ? Data$dMaybe.$Maybe("Just", {lon: v3._1.location.longitude, lat: v3._1.location.latitude})
            : Data$dMaybe.Nothing)
        );
      }
      return Data$dMaybe.Nothing;
    })(shouldSubmit._1))($2)))(deliveringRestaurantsResult => subscribeDyn_(result => {
      const $3 = Web$dDOM$dParentNode.querySelectorAll(".js-delivery-details--ok, .js-delivery-details--error")($0);
      return () => {
        const allResults = $3();
        const a$p = Web$dDOM$dNodeList.toArray(allResults)();
        for_1(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(Web$dInternal$dFFI.unsafeReadProtoTagged("Element"))(a$p)))(Utils$dDOM.hide)();
        if (result._1.tag === "Just") {
          if (result._2.tag === "Loaded") {
            if (result._2._1.tag === "Right") {
              if (result._2._1._1.length === 0) {
                shouldSubmit._2(_old => false)();
                const errors = Web$dDOM$dParentNode.querySelector(".js-delivery-details--error")($0)();
                return for_2(errors)(Utils$dDOM.show)();
              }
              shouldSubmit._2(_old => false)();
              const v2 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, result._2._1._1, 0);
              if (v2.tag === "Just") {
                const $4 = v2._1;
                const itemDiv = Web$dDOM$dParentNode.querySelector(".js-delivery-details--ok[data-restaurant=\"" + Data$dShow.showIntImpl(Data$dRecord.unsafeGet("id")($4)) + "\"]")($0)();
                return for_2(itemDiv)(item => {
                  const $5 = Utils$dDOM.show(item);
                  return () => {
                    $5();
                    const deliveryCost = Web$dDOM$dParentNode.querySelector(".js-delivery-details__delivery-cost")(item)();
                    return for_2(Data$dRecord.unsafeGet("deliveryInfo")($4))(info => {
                      const $6 = for_2(deliveryCost)(Utils$dDOM.setInnerText(Restaumatic$dSite$dI18n.currency(Data$dRecord.unsafeGet("deliveryCost")(info))));
                      return () => {
                        $6();
                        const minOrderValue = Web$dDOM$dParentNode.querySelector(".js-delivery-details__min-order-value")(item)();
                        for_2(minOrderValue)(Utils$dDOM.setInnerText(Restaumatic$dSite$dI18n.currency(Data$dRecord.unsafeGet("minOrderValue")(info))))();
                        const $7 = Web$dHTML.window();
                        const $8 = Web$dHTML$dWindow.location($7)();
                        const origin$p = Web$dHTML$dLocation.origin($8)();
                        const $9 = Data$dRecord.unsafeGet("slug")($4);
                        const link = Web$dDOM$dParentNode.querySelector(".js-delivery-details__button")(item)();
                        for_2($9.tag === "Just" ? Data$dMaybe.$Maybe("Just", origin$p + "/restauracja/" + $9._1) : Data$dMaybe.Nothing)((() => {
                          const $10 = for_2(link);
                          const $11 = Web$dDOM$dElement.setAttribute("href");
                          return x => $10($11(x));
                        })())();
                        const freeThreshold = Web$dDOM$dParentNode.querySelector(".js-delivery-details__free-threshold")(item)();
                        return for_2(freeThreshold)(threshold => {
                          const $10 = Utils$dDOM.parentNode$p(threshold);
                          return () => {
                            const freeThresholdParent = $10();
                            const v3 = Data$dRecord.unsafeGet("freeDeliveryThreshold")(info);
                            if (v3.tag === "Nothing") { return Utils$dDOM.hide(freeThresholdParent)(); }
                            if (v3.tag === "Just") {
                              Utils$dDOM.show(freeThresholdParent)();
                              return Utils$dDOM.setInnerText(Restaumatic$dSite$dI18n.currency(v3._1))(threshold)();
                            }
                            $runtime.fail();
                          };
                        })();
                      };
                    })();
                  };
                })();
              }
              if (v2.tag === "Nothing") { return; }
              $runtime.fail();
            }
            return;
          }
          return;
        }
      };
    })(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dTuple.Tuple)($2))(deliveringRestaurantsResult))))))))));
  }))();
  return Utils$dDOM.show(form)();
};
const headE = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const bind3 = Monad0.Bind1().bind;
  const foldDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP);
  const pure3 = Monad0.Applicative0().pure;
  return e => bind3(foldDyn(v => n => n + 1 | 0)(0)(e))(occurences => pure3(Specular$dFRP$dBase.filterMapEvent(v => {
    if (v._1 === 1) { return Data$dMaybe.$Maybe("Just", v._2); }
    return Data$dMaybe.Nothing;
  })(Specular$dFRP$dBase.attachDynWith(Data$dTuple.Tuple)(occurences)(e))));
};
export {$DeliveryStatus, OK, OTHER, UNKNOWN, asyncRequestMaybe, attachEvent, bind, for_, for_1, for_2, headE, init, monadFRP, newEvent, newRef, parseAccountId, pure, subscribeDyn_};
